

















































































































import { Component, Vue } from "vue-property-decorator";
import PropertyBulkEdit from "@/components/property/propertyBulkEdit.vue";
import QCompanySelect from "@/common/qCompanySelect.vue";
import QUserSelect from "@/common/qUserSelect.vue";
import QErrors from "@/common/qErrors.vue";
import { namespace } from "vuex-class";
import Company from "@/model/company";
import companyApi from "@/api/companyApi";

const auth = namespace("Auth");
@Component({
  name: "PropertyBulkEditLimit",
  directives: {},
  components: {
    PropertyBulkEdit,
    QCompanySelect,
    QUserSelect,
    QErrors,
  },
})
export default class PropertyBulkEditLimit extends Vue {
  @auth.Getter
  getCurrentyCompany!: Company;
  @auth.Getter
  isAdmin!: boolean;

  public selfOwnerCompany: Company = new Company();
  mounted() {
    if (!this.isAdmin) {
      this.getCompanyInfo();
    }
  }

  public async getCompanyInfo() {
    const result = await companyApi.show(this.ownerCompanyId);
    this.selfOwnerCompany = new Company(result.data);
  }

  get ownerCompanyId() {
    if (this.isAdmin) {
      return null;
    }
    return this.getCurrentyCompany.pivot.affiliation_company_id;
  }
  get manageCompanyId() {
    if (this.isAdmin) {
      return null;
    }
    return this.getCurrentyCompany.id;
  }
}
